import OrgChartData from './OrgChartData';
export default OrgChartData;
